module.exports = __webpack_public_path__ + "static/sales-history-85bee3dfce58c26c6487206d618a2776.png";